import ReactGA from "react-ga4";
import { appName, isEmbroideryTrace, isSvgTrace } from "../../config/appVariant";

/** SvgTrace app — legacy default when env var is unset. */
const SVGTRACE_GA_ID = "G-YTYW71WQNH";
const EMBROIDERYTRACE_GA_ID = "G-8HQZHFXRV9";

const measurementId =
  process.env.REACT_APP_GA_MEASUREMENT_ID ||
  (isEmbroideryTrace ? EMBROIDERYTRACE_GA_ID : isSvgTrace ? SVGTRACE_GA_ID : "");

let initialized = false;

export function getGaMeasurementId() {
  return measurementId;
}

export function isGaEnabled() {
  return !!measurementId;
}

/**
 * EmbroideryTrace shares its marketing web stream so the landing-to-signup
 * journey can be measured together. SvgTrace retains its separate property.
 */
export function initializeGa4() {
  if (initialized) return true;
  if (process.env.NODE_ENV !== "production") return false;
  if (!measurementId) {
    if (process.env.NODE_ENV !== "production") {
      console.info(`[GA4] No measurement ID configured for ${appName}`);
    }
    return false;
  }

  ReactGA.initialize(measurementId, {
    gaOptions: {
      send_page_view: false,
    },
    gtagOptions: {
      app_name: appName,
      app_variant: isEmbroideryTrace ? "embroiderytrace" : "svgtrace",
    },
  });

  initialized = true;
  return true;
}

/** Track SPA route changes. */
export function trackGaPageView(path, title = document.title) {
  if (!initialized) return;
  ReactGA.send({
    hitType: "pageview",
    page: path,
    title,
  });
}

/** Track a GA4 event with app context on every hit. */
export function trackGaEvent(name, params = {}) {
  if (!initialized) return;
  ReactGA.event(name, {
    app_name: appName,
    app_variant: isEmbroideryTrace ? "embroiderytrace" : "svgtrace",
    ...params,
  });
}
